import { render, staticRenderFns } from "./ResultPerPage.vue?vue&type=template&id=17e2ae58&scoped=true&"
import script from "./ResultPerPage.vue?vue&type=script&lang=js&"
export * from "./ResultPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2ae58",
  null
  
)

export default component.exports